// First-party cookie that carries a referral code across the signup +
// OAuth round-trip. NON-httpOnly by design: the code grants nothing, and the
// client must read it later to POST the attribution claim — the API is a
// different origin, so the cookie can't be auto-sent; the value goes in the
// request body. Living on the web origin is what makes it survive the OAuth
// hop back to /auth/finishing.

const SIGNUP_REF_COOKIE = 'signup_ref';
const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 30; // ~30 days
// Codes are opaque tokens; reject anything else before it touches the cookie
// or the claim body. Matches the server's accepted code shape.
const CODE_RE = /^[A-Za-z0-9_-]{1,64}$/;

export function isValidReferralCode(code: string): boolean {
  return CODE_RE.test(code);
}

export function storeSignupRef(code: string): void {
  if (typeof document === 'undefined') return;
  if (!isValidReferralCode(code)) return;
  document.cookie =
    `${SIGNUP_REF_COOKIE}=${encodeURIComponent(code)}; Path=/; SameSite=Lax; Max-Age=${COOKIE_MAX_AGE_SECONDS}`;
}

export function readSignupRef(): string | null {
  if (typeof document === 'undefined') return null;
  const m = document.cookie.match(
    new RegExp(`(?:^|;\\s*)${SIGNUP_REF_COOKIE}=([^;]+)`),
  );
  if (!m || m[1] === undefined) return null;
  const value = decodeURIComponent(m[1]);
  return isValidReferralCode(value) ? value : null;
}

export function clearSignupRef(): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${SIGNUP_REF_COOKIE}=; Path=/; SameSite=Lax; Max-Age=0`;
}
